<mat-dialog-content>
  <div class="dialog-header">
    <h4 mat-dialog-title class="dialog-title">Tem a certeza?</h4>
  </div>
  <div class="dialog-body">
    @if (data.extraText) {
      <p class="dialog-content">{{ data.extraText }}</p>
    }
  </div>
  <div class="dialog-footer">
    <div mat-dialog-actions class="dialog-actions">
      <button type="button" mat-raised-button (click)="onCancel()">Não</button>
      <button type="button" mat-raised-button color="primary" (click)="onConfirm()" cdkFocusInitial>Sim</button>
    </div>
  </div>
</mat-dialog-content>